import { useCallback, useEffect } from 'react';

import { useStatsStore, useStatisticOptions } from '../store';

export const useStatisticFilters = () => {
  const { options } = useStatisticOptions();
  const filters = useStatsStore((state) => state.filters);
  const setFilters = useStatsStore((state) => state.setFilters);

  useEffect(() => {
    !filters && setFilters(options?.defaultFilters);
  }, [setFilters, filters, options?.defaultFilters]);

  const resetFilters = useCallback(() => {
    setFilters(options?.defaultFilters);
  }, [setFilters, options?.defaultFilters]);

  return { filters, setFilters, resetFilters };
};
